import React from 'react';
import clsx from 'clsx';
import Slider from 'react-slick';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  slider: {
    '& .slick-prev': {
      left: -20,
    },
    '& .slick-next': {
      right: -20,
    },
    '& .slick-track': {
      display: 'flex',
    },
    '& .slick-slide': {
      margin: 'auto 0',
    },
  },
}));

const ImageSlider = ({ images }) => {
  const classes = useStyles();
  return (
    <Slider speed={500} className={clsx(classes.slider, 'service-list-slick')}>
      {images.map((image, index) => (
        <img key={index} src={image} alt="" />
      ))}
    </Slider>
  );
};

export default ImageSlider;
